var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStandardOs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_560",
    "data-name": "Group 560",
    transform: "translate(-937 -468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_559",
    "data-name": "Group 559",
    transform: "translate(0 206)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 74,
    height: 75,
    rx: 6,
    transform: "translate(937 262)",
    fill: "#3f4053"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Standard",
    transform: "translate(941.5 280)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Standard")), /*#__PURE__*/React.createElement("text", {
    id: "OS",
    transform: "translate(946 322)",
    fill: "#fff",
    fontSize: 40,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "OS"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardOs);
export default __webpack_public_path__ + "static/media/standardOS.c591413d15e239392c2f25c1b3b49f90.svg";
export { ForwardRef as ReactComponent };